import { useState } from 'react';

const useConfirmationDialog = () => {
  const [open, setOpen] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [onConfirm, setOnConfirm] = useState(() => () => {});

  const show = (confirmAction, isPending = false) => {
    setOnConfirm(() => confirmAction);
    setOpen(true);
    setIsPending(isPending);
  };

  const handleConfirm = () => {
    onConfirm();
    !isPending && setTimeout(() => setOpen(false), 1200);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return {
    open,
    show,
    handleConfirm,
    handleClose,
  };
};

export default useConfirmationDialog;
